import type { WebChatStorage } from '@revocom/webchat-sdk';

/** Browser localStorage adapter for SDK session persistence. */
export class LocalStorageAdapter implements WebChatStorage {
  private readonly prefix: string;

  constructor(widgetId: string) {
    this.prefix = `revocom.webchat.${widgetId}.`;
  }

  getItem(key: string): string | null {
    try {
      return localStorage.getItem(this.prefix + key);
    } catch {
      return null;
    }
  }

  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(this.prefix + key, value);
    } catch {
      // Private browsing / quota — ignore.
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(this.prefix + key);
    } catch {
      // ignore
    }
  }
}
